import React from "react";
import TripRequestPage from "./screens/ListOfTripRequest/TripRequestPage";
import TripDetails from "./screens/Trip Details/TripDetails";
import EscortDetails from "./screens/EscortApproval/EscortDetails";
import "./App.css";
import ROUTE_PATHS from "./utils/routePaths";
import PageNotFound from "./components/elements/PageNotFound";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import AfterHoursDetails from "./screens/AfterHours/AfterHoursDetails";
import HistoricTripsPage from "./screens/HistoricTrips/HistoricTripsPage";
import HistoricTripsDetails from "./screens/HistoricTrips/views/HistoricTripsDetails";
import NotificationsScreen from './screens/Notifications/NotificationsScreen';
import UnregisteredAircraftTripsPage from "./screens/UnregisteredAircraftTrips/UnregisteredAircraftTripsPage";
import UnregisteredAircraftTripsDetails from "./screens/UnregisteredAircraftTrips/UnregisteredAircraftTripsDetails";
import UnregisteredAircraftTripDetails from "./screens/UnregisteredAircraftTrips/UnregisteredAircraftTripDetails";

const App = () => {
  return (

    <Routes path="auth">
      <Route path={ROUTE_PATHS.HOME} element={<Navigate to={ROUTE_PATHS.TRIP_REQUEST_PAGE} replace />} />
      <Route path={ROUTE_PATHS.TRIP_REQUEST_PAGE} element={<TripRequestPage />} />
      <Route path={ROUTE_PATHS.TRIP_DETAILS()} element={<TripDetails />} />
      <Route path={ROUTE_PATHS.ESCORT_DETAILS()} element={<EscortDetails />} />
      <Route path={ROUTE_PATHS.AFTER_HOURS_DETAILS()} element={<AfterHoursDetails />} />
      <Route path={ROUTE_PATHS.HISTORIC_TRIPS_PAGE} element={<HistoricTripsPage />} />
      <Route path={ROUTE_PATHS.HISTORIC_TRIP_DETAILS()} element={<HistoricTripsDetails />} />
      <Route path={ROUTE_PATHS.NOTIFICATIONS_PAGE} element={<NotificationsScreen />} />
      <Route path={ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIPS_PAGE} element={<UnregisteredAircraftTripsPage />} />
      <Route path={ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIPS_DETAILS} element={<UnregisteredAircraftTripsDetails />} />
      <Route path={ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIP_DETAILS} element={<UnregisteredAircraftTripDetails />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default App;
